/* -------------------------------------------
Imports
------------------------------------------- */

import GoogleMapController from 'scripts/classes/map';
import MapStyles from 'scripts/components/map-styles';
import HighlightController from 'scripts/classes/highlighter';

/* -------------------------------------------
Variables
------------------------------------------- */

// A script to load the google maps api
const script = document.createElement('script');
// The google maps api key
const key = 'AIzaSyDV4ehIn9GEC8wwXRaRbPdU0Lrj_QOhp2w';

/* -------------------------------------------
Load the script
------------------------------------------- */

script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=GoogleMapsLoaded`;
script.async = true;
script.defer = true;
document.body.appendChild(script);

/* -------------------------------------------
Page setup
------------------------------------------- */

window.GoogleMapsLoaded = () => {
  Watcher.observe('.js-default-map', blocks => {
    // Loop the blocks array
    blocks.forEach(block => {
      // Whether the map has been initialized
      let initialized = false;
      // Find the filters form
      const form = block.querySelector('.js-default-map__form');
      // Find the search input
      const search = form.querySelector('[name="keyword"]');

      // Find the map
      const map = block.querySelector('.js-default-map__map');
      // Find the results
      const results = block.querySelector('.js-default-map__results');
      // An array of all the items
      const list = [];

      // Find this block's data
      const locations = window[block.id];

      // Create a new HighlightController
      const Highlighter = new HighlightController();

      /* -------------------------------------------
      Map setup
      ------------------------------------------- */

      // Create a new map controller
      const GoogleMap = new GoogleMapController({
        center: {
          lat: -41.2865,
          lng: 174.7762
        },
        zoom: 6
      });
      const addInfoWindows = () => {
        GoogleMap.addInfoWindows(data => {
          return `
            <div class="default-map-info-window">
              <div class="default-map-info-window__details">
                ${data.title ? `<span class="default-map-info-window__title colour--${window.PinColour.classes || window.ThemeColours.secondary.classes}">${data.title}</span>` : ''}
                ${data.address ? `<span class="default-map-info-window__address">${data.address}</span>` : ''}
                ${data.pobox ? `<span class="default-map-info-window__address">${data.pobox}</span>` : ''}
                ${data.email ? `<span class="default-map-info-window__link">${data.email}</span>` : ''}
                ${data.phone ? `<span class="default-map-info-window__link">${data.phone}</span>` : ''}
                <a href="${data.link}" class="default-map-info-window__button read-more colour--${window.PinColour.classes || window.ThemeColours.secondary.classes}">Find advisor</a>
              </div>
            </div>
          `;
        });
      };
      const updateMapMarkers = function () {
        let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // Clear the existing markers
        GoogleMap.clearMarkers();

        // Loop the items
        items.forEach(item => {
          // Add a marker to the map
          GoogleMap.addMarker(item.data, {
            fillColor: window.PinColour.hex || window.ThemeColours['primary'].hex
          });
        });
        setTimeout(() => {
          GoogleMap.recenter();
        }, 500);

        // Add the info windows
        addInfoWindows();
      };
      const updateMapList = function () {
        let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // Set the map list html
        results.innerHTML = items.map(item => item.html).join('');
        // Highlight the searched items
        // highlightSearchedItems();

        list.length = 0;
        list.push(...results.children);
      };

      // Add the GoogleMap to the map
      map.appendChild(GoogleMap.element);

      // Set the map styles
      GoogleMap.setStyles(MapStyles);
      updateMapMarkers(locations);
      updateMapList(locations);
      GoogleMap.recenter();

      /* -------------------------------------------
      Document Setup
      ------------------------------------------- */

      // When the search input is changed
      search.addEventListener('input', () => {
        // Set a new highlighter term
        Highlighter.setTerm(search.value);
        list.forEach(item => {
          Highlighter.mark(item);
        });
        if (search.value === '') {
          list.forEach(item => {
            // Add the item to the results
            results.appendChild(item);

            // Put the markers back on the map
            GoogleMap.markers.forEach(marker => {
              marker.pin.setMap(GoogleMap.map);
            });
          });
        } else {
          // Loop the children in the results and hide them
          [...results.children].forEach(item => {
            item.parentNode.removeChild(item);

            // Remove the marker from the map
            GoogleMap.markers.forEach(marker => {
              marker.pin.setMap(null);
            });
          });
          Highlighter.marked.forEach(item => {
            results.appendChild(item);
            GoogleMap.markers.forEach(marker => {
              if (marker.data.id == item.id) {
                marker.pin.setMap(GoogleMap.map);
              }
            });
          });
          if (![...results.children].length) {
            results.innerHTML = '';
          }
        }
        GoogleMap.recenter();
      });
      if (search.value) SearchableContent.setTerm(search.value);
      form.addEventListener('submit', e => {
        e.preventDefault();
      });
    });
  });
};